// 第3张
const imgAll3 = {
    JP: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1724642305224/a3.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1724642845675/c3.jpg',
    },
    NA: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1724642305224/a3.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1724642845675/c3.jpg',
    },
    EU: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725092258199/a3.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1725092748136/b3.jpg',
    },
    UK: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725093142504/uk3.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1725093604501/uk3.jpg',
    },
};
export const imgLocale3: any = {
    jp: imgAll3.JP,
    us: imgAll3.NA,
    ca: imgAll3.NA,
    br: imgAll3.NA,
    mx: imgAll3.NA,
    uk: imgAll3.UK,
    eu: imgAll3.EU,
    de: imgAll3.EU,
    fr: imgAll3.EU,
    it: imgAll3.EU,
    es: imgAll3.EU,
};
